export const lotteryBrandName: string = $localize`LV Wheel`;
